import { render, staticRenderFns } from "./SortedAllergenSummary.vue?vue&type=template&id=6326d5bc&scoped=true&"
import script from "./SortedAllergenSummary.vue?vue&type=script&lang=ts&"
export * from "./SortedAllergenSummary.vue?vue&type=script&lang=ts&"
import style0 from "./SortedAllergenSummary.vue?vue&type=style&index=0&id=6326d5bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6326d5bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
